import { styled } from '@material-ui/core';

export const OverLay = styled('div')({
	position: 'fixed',
	width: '100%',
	height: '100%',
	background: 'var(--color-bg-overlay)',
	top: 0,
	left: 0,
	zIndex: 1040,
});

export const HeaderBackgroundOverLay = styled('div')({
	position: 'fixed',
	width: '100%',
	height: 345,
	background: 'var(--color-bg-primary)',
	top: 0,
	left: 0,
	transition: 'background-color var(--transition-normal)',
});

export const MainContainer = styled('div')({
	width: '100%',
	height: '100vh',
	background: 'var(--color-bg-primary)',
	overflow: 'auto',
	display: 'flex',
	flexDirection: 'column',
	transition: 'background-color var(--transition-normal)',
});

export const ChildrenContainer = styled('div')({
	zIndex: 2,
	position: 'relative',
	height: 'auto',
	margin: '0 auto',
	boxSizing: 'border-box',
	paddingTop: 45,
	maxWidth: 1440,
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
});
